















import { Vue, Prop, Component } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
@Component({
  name: 'MainTitle',
  components: { Chart }
})
export default class extends Vue {
  @Prop({ default: '#00B66C' }) private color!: string
  @Prop() private normData!: any
  @Prop() private data!: any
  @Prop() private names!: any

  private chartId: string = ''

  created() {
    this.chartId = new Date().getTime() + '_' + parseInt(Math.random() * 10000000 + '')
    this.names.map(v => {
      this.option.radar.indicator.push({
        name: v,
        max: 100
      })
      this.option.series[0].data[0].value.push(100)
      this.option.series[1].data[0].value.push(100)
    })
    this.option.series[1].data[0].name = this.data
    this.option.series[2].data[0].value = this.data
    this.option.series[3].data[0].value = this.normData
  }
  private option: any = {
    color: ['#FF9B6F'],
    animation: false,
    radar: {
      // startAngle: 60,
      splitNumber: 4,
      radius: '60%',
      splitArea: {
        areaStyle: {
          color: ['#FFFFFF']
        }
      },
      axisLine: {
        lineStyle: {
          color: '#FFE0D2'
        }
      },
      splitLine: {
        lineStyle: {
          color: ['#FFE0D2', '#FFE0D2', '#FFE0D2', '#FFE0D2', '#FF9B6F']
        }
      },
      shape: 'circle',
      name: {
        textStyle: {
          color: '#999999',
          fontSize: 12
        },
        formatter: function(value, indicator) {
          if (value === '肌肉力量') {
            return `{a|${value}}`
          } else {
            return `${value}`
          }
        },
        rich: {
          a: {
            padding: [10, 0, 0, 0]
          }
        }
      },
      indicator: []
    },
    series: [{
      animation: false,
      name: '',
      type: 'radar',
      symbol: 'circle',
      // symbolSize: 5,
      label: {
        show: true,
        position: 'inside',
        formatter: function(params, ticket, callback) {
          return `{${params.dimensionIndex}|  }`
        },
        rich: {
          0: {
            backgroundColor: '#FF9B6F',
            borderRadius: 50,
            borderColor: '#ffffff',
            borderWidth: 3,
            height: 10,
            width: 10
          },
          1: {
            backgroundColor: '#FF9B6F',
            borderRadius: 50,
            borderColor: '#ffffff',
            borderWidth: 3,
            height: 10,
            width: 10
          },
          2: {
            backgroundColor: '#FF9B6F',
            borderRadius: 50,
            borderColor: '#ffffff',
            borderWidth: 3,
            height: 10,
            width: 10
          },
          3: {
            backgroundColor: '#FF9B6F',
            borderRadius: 50,
            borderColor: '#ffffff',
            borderWidth: 3,
            height: 10,
            width: 10
          },
          4: {
            backgroundColor: '#FF9B6F',
            borderRadius: 50,
            borderColor: '#ffffff',
            borderWidth: 3,
            height: 10,
            width: 10
          },
          5: {
            backgroundColor: '#FF9B6F',
            borderRadius: 50,
            borderColor: '#ffffff',
            borderWidth: 3,
            height: 10,
            width: 10
          },
          6: {
            backgroundColor: '#FF9B6F',
            borderRadius: 50,
            borderColor: '#ffffff',
            borderWidth: 3,
            height: 10,
            width: 10
          }
        }
      },
      itemStyle: {
        color: 'none',
        borderColor: 'none',
        borderWidth: 3
      },
      areaStyle: {
        color: 'none'
      },
      lineStyle: {
        color: 'none'
      },
      data: [{
        value: []
      }]
    }, {
      animation: false,
      name: '',
      type: 'radar',
      symbol: 'circle',
      label: {
        show: true,
        position: 'top',
        formatter: function(params, ticket, callback) {
          // const val = params.name[params.dimensionIndex] + '分'
          const val = params.name[params.dimensionIndex]
          return `{${params.dimensionIndex}|${val}}`
        },
        rich: {
          0: {
            color: '#FF9B6F',
            padding: [2, 0, 0, 0],
            fontWeight: 500,
            fontSize: 12
          },
          1: {
            color: '#FF9B6F',
            padding: [-40, 70, 0, 0],
            fontWeight: 500,
            fontSize: 12
          },
          2: {
            color: '#FF9B6F',
            padding: [-70, 0, 0, -35],
            fontWeight: 500,
            fontSize: 12
          },
          3: {
            color: '#FF9B6F',
            padding: [-70, 0, 0, 60],
            fontWeight: 500,
            fontSize: 12
          },
          4: {
            color: '#FF9B6F',
            padding: [-40, 0, 0, 80],
            fontWeight: 500,
            fontSize: 12
          },
          5: {
            color: '#FF9B6F',
            padding: [-50, 0, 0, 50],
            fontWeight: 500,
            fontSize: 12
          },
          6: {
            color: '#FF9B6F',
            padding: [-30, 0, 0, 70],
            fontWeight: 500,
            fontSize: 12
          }
        }
      },
      itemStyle: {
        color: 'none',
        borderColor: 'none',
        borderWidth: 3
      },
      areaStyle: {
        color: 'none'
      },
      lineStyle: {
        color: 'none'
      },
      data: [{
        value: [],
        name: []
      }]
    }, {
      // animation: false,
      name: '',
      type: 'radar',
      symbol: 'none',
      itemStyle: {
        normal: {
          areaStyle: {
            color: 'rgba(251, 131, 77, 0.43)'
          }
        }
      },
      data: [{
        value: [],
        name: ''
      }],
      z: 10
    }, {
      // animation: false,
      name: '',
      type: 'radar',
      symbol: 'none',
      itemStyle: {
        normal: {
          areaStyle: {
            color: '#FFFFFF'
          }
        }
      },
      lineStyle: {
        color: '#666666',
        type: 'dotted'
      },
      data: [{
        value: [],
        name: ''
      }]
    }]
  }
}
